
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppStateService } from 'core/app-state/app-state.service';
import { AppLocalization } from '../../shared/entities/app-localization';

@Component({
  selector: 'app-view-offline-status',
  templateUrl: './view-offline-status.component.html',
  styleUrls: ['./view-offline-status.component.scss'],
  standalone: false
})
export class ViewOfflineStatusComponent implements OnInit {
  tabOptions = ['errorList', 'syncHistory'];
  tab;
  entityId;
  // sub pages select what components should be handled within the tab
  subPage = null;
  selectedTab;
  appStrings: AppLocalization;
  isOnline: boolean;
  pageSize = 50;
  currentPage = 0;

  constructor(
    private appInfoService: AppInfoService,
    private appStateService: AppStateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.isOnline = this.appStateService.state.isOnline;
    this.appStrings = this.appInfoService.appStrings;
    const defaultTab = this.activatedRoute.snapshot.paramMap.get('tabName');
    if (defaultTab === 'errorList') {
      this.selectedTab = 0;
    } else {
      this.selectedTab = 1;
    }
  }

  updateTab(tab) {
    if (this.selectedTab === tab) {
      return;
    }
    this.selectedTab = tab;
    const updatedPath = ['/' + this.route.snapshot.url[0].path];
    if (this.tabOptions[tab]) {
      updatedPath.push(this.tabOptions[tab]);
    }
    this.router.navigate(updatedPath);
  }

}
